// extracted by mini-css-extract-plugin
export default {"v2FuzzyOptionWrap":"v2FuzzyOptionWrap--vpNKB","markerAnimationScale":"markerAnimationScale--uen09"};